
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { AccountingDocumentTypeEnum } from '@gid/models';

@Component({})
export default class PaymentAmount extends Vue {
  @Prop({ required: true }) amount!: number;
  @Prop() documentType!: string;
  // ISO 4217 code from the payment record; EUR default keeps the legacy
  // behaviour for consumers that don't pass it.
  @Prop({ default: 'EUR' }) currency!: string;

  get formattedAmount() {
    // Locale follows the active app locale (the same `locale` store getter the
    // rest of the apps format currency with, e.g. ServicesPreview/Quote) so
    // digit grouping and symbol placement match the user's language rather than
    // being pinned to de-DE.
    return new Intl.NumberFormat(this.$store.getters.locale, {
      style: 'currency',
      currency: this.currency || 'EUR',
    }).format(this.shownAmount);
  }

  get shownAmount() {
    if (
      this.documentType &&
      this.documentType === AccountingDocumentTypeEnum.CREDIT_NOTE
    ) {
      return -this.amount;
    }
    return this.amount;
  }

  get textClass() {
    return {
      'text-danger': this.shownAmount < 0,
      'text-success': this.shownAmount > 0,
      'bg-white': true,
    };
  }
}
